import { ASANA_MIGRATION_VOID_COLORS, COLOURS, sectionColors } from "../constants"

export function getRandomColor(index) {
  if (index > -1) {
    return COLOURS[index % COLOURS.length];
  }
  return COLOURS[Math.floor(Math.random() * COLOURS.length)];
}

export function getSectionColor(index) {
  return sectionColors[index % sectionColors.length];
}

export const getTagColor = (color) => {
  if (!color) return 'blue';
  // Hex colors from the backend color picker always take priority
  if (color.startsWith('#')) return color;
  // Legacy Asana named colors — filter out void/invalid ones
  return !ASANA_MIGRATION_VOID_COLORS?.includes(color) ? color : 'blue';
}

export function getPortfolioColor(id) {
  if (!id) return COLOURS[0];

  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash);
  return COLOURS[index % COLOURS.length];
}